<template>
  <mobile-filesystem-container>

    <mobile-filesystem-header :filesystem-id="filesystemId"
                              @newFile="showingFileUpload = true"
                              @searching="search" @searchCleared="closeSearch"
                              :refresh="refresh"></mobile-filesystem-header>

    <mobile-filesystem-search-navigation v-if="searching" @back="closeSearch"/>
    <mobile-filesystem-breadcrumbs v-else @clicked="fetchDirectory" @home="fetch" :breadcrumbs="breadcrumbs"/>


    <main class="w-full flex flex-wrap gap-4">
      <template v-if="loading">
        <mobile-filesystem-directory-loading :key="`${directory}-loading`"
                                             v-for="directory in [...Array(30).keys()]"/>
      </template>
      <template v-else>
        <template v-if="showingFileUpload">
          <mobile-filesystem-upload-navigation @back="refresh()"/>
          <mobile-dropzone :filesystem-id="filesystemId" :directory-id="currentDirectoryId"></mobile-dropzone>
        </template>
        <template v-else>
          <template v-if="workingDirectories.length">
            <mobile-filesystem-directory @clicked="highlightDirectory"
                                         @doubleClicked="fetchDirectory"
                                         :highlighted="directory.highlighted"
                                         v-for="directory in workingDirectories"
                                         :key="`dir-${directory.id}`"
                                         :directory="directory"/>
          </template>
          <template v-if="workingFiles.length">
            <mobile-filesystem-file
                @clicked="highlightFile"
                @doubleClicked="preview"
                :highlighted="file.highlighted"
                :key="`file-${file.id}`"
                v-for="file in workingFiles"
                :file="file"/>
          </template>
        </template>
      </template>
    </main>

  </mobile-filesystem-container>
</template>

<script>
import MobileFilesystemContainer from "./MobileFilesystemContainer.vue";
import MobileFilesystemHeader from "./MobileFilesystemHeader.vue";
import MobileFilesystemDirectory from "./MobileFilesystemDirectory.vue";
import MobileFilesystemFile from "./MobileFilesystemFile.vue";
import MobileFilesystemBreadcrumbs from "./MobileFilesystemBreadcrumbs.vue";
import {Directory, Filesystem} from "@models";

const getBreadcrumbsUpToId = (breadcrumbs, id) => {
  const index = breadcrumbs.findIndex(breadcrumb => breadcrumb.id === id)

  if (index === -1) return breadcrumbs

  return breadcrumbs.slice(0, index)
}

export default {
  components: {
    MobileFilesystemDirectory,
    MobileFilesystemHeader,
    MobileFilesystemContainer,
    MobileFilesystemFile,
    MobileFilesystemBreadcrumbs
  },
  props: ['filesystemId', 'filesystemTitle'],
  data() {
    return {
      files: [],
      directories: [],
      errors: null,
      breadcrumbs: [],
      searching: false,
      search_files: [],
      search_directories: [],
      loading: true,
      currentDirectoryId: null,
      showingFileUpload: false
    }
  },
  computed: {
    workingFiles() {
      return this.searching ? this.search_files : this.files
    },
    workingDirectories() {
      return this.searching ? this.search_directories : this.directories
    }
  },
  watch: {
    dragging(newVal) {
    },
  },
  methods: {
    clearHighlights() {
      if (this.directories && this.directories.length) {
        this.directories.forEach(directory => directory.highlighted = false)
      }
      if (this.files && this.files.length) {
        this.files.forEach(file => file.highlighted = false)
      }
    },
    highlightDirectory(event) {
      this.clearHighlights()
      this.directories = this.directories.map((directory) => {
        directory.highlighted = directory.id === event[0]
        return directory
      })
    },
    highlightFile(event) {
      this.clearHighlights()
      this.files = this.files.map((file) => {
        file.highlighted = file.id === event[0]
        return file
      })
    },
    closeSearch() {
      this.searching = false
      this.search_files = []
      this.search_directories = []
    },
    async search(terms) {
      this.loading = true

      const {files, directories} = await Filesystem.search(this.filesystemId, terms)
      this.search_files = files
      this.search_directories = directories

      this.searching = true

      this.loading = false
    },
    async fetch() {
      this.closeSearch()
      this.showingFileUpload = false
      this.currentDirectoryId = null
      this.loading = true

      const {files, directories} = await Filesystem.get(this.filesystemId)
      this.files = files
      this.directories = directories
      this.breadcrumbs = []

      this.loading = false
    },
    async refresh() {
      this.showingFileUpload = false
      this.closeSearch()
      if (this.currentDirectoryId) {
        await this.fetchDirectory(this.currentDirectoryId)
      } else {
        await this.fetch()
      }
    },
    async fetchDirectory(directoryId) {
      this.closeSearch()
      this.loading = true

      const directoryData = await Directory.get(directoryId)
      this.files = directoryData.files
      this.directories = directoryData.directories

      this.breadcrumbs = getBreadcrumbsUpToId(this.breadcrumbs, directoryId)

      this.breadcrumbs.push({
        id: directoryId,
        name: directoryData.name
      })

      this.loading = false
    },
    preview(object) {
      this.$modals.open('mobile-filesystem-preview-modal', {
        filesystemId: this.filesystemId,
        previewObject: object.getPreviewObject(),
        refresh: this.refresh,
        close: () => {
        }
      })
    }
  },
  mounted() {
    this.fetch()
  }
}
</script>

